export const isOneDigitNumber = /^[0-9]{1}$/
